import axios from "axios";
const CancelToken = axios.CancelToken;
let cancelFetchVenuesForGivenGroupsAndBrands = () => {};
let cancelfetchHotelGroupsForAnalytics = () => {};
const fetchHotelGroups = async token => {
  try {
    const response = await axios.get(
      `${window.API}/api/hotel-groups?parentGroups`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {}
};
const fetchHotelGroupsForAnalytics = async token => {
  cancelfetchHotelGroupsForAnalytics()
  try {
    const response = await axios.get(
      `${window.API}/api/hotel-groups/analytics?parentGroups=true`,
      {
        headers: { Authorization: `Bearer ${token}` },
        cancelToken: new CancelToken(function executor(c) {
          cancelfetchHotelGroupsForAnalytics = c;
        }),
      },

    );
    return response.data;
  } catch (error) {}
};
const fetchVenuesForGivenGroupsAndBrands = async (
  hotelGroups,
  permissionToCheck = null,
  token,
  includeChildren = false,
  isNonAnalytics = false,
) => {
  try {
    cancelFetchVenuesForGivenGroupsAndBrands();
    const response = await axios.get(
      `${window.API}/api/hotel-group-venues?hotelGroups=${hotelGroups.join(
        ","
      )}${includeChildren ? "&includeChildren=true" : ""}${permissionToCheck ? `&permissionToCheck=${permissionToCheck}` : ""}${isNonAnalytics ? `&isNonAnalytics=${isNonAnalytics}` : ""}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        cancelToken: new CancelToken(function executor(c) {
          cancelFetchVenuesForGivenGroupsAndBrands = c;
        }),
      }
    );
    return response.data;
  } catch (error) {}
};

export {
  fetchVenuesForGivenGroupsAndBrands,
  fetchHotelGroups,
  fetchHotelGroupsForAnalytics,
};
